module.exports = __webpack_public_path__ + "media/validations-dashboard.d05a6931.mp4";